
import { defineComponent } from 'vue';
import type { PropType } from 'vue';
import { piniaAvailable } from '../helpers/piniaStoreAvailable';
import TransitionExpand from './TransitionExpand.vue';
import HokImg from './HokImg.vue';
import { getPaymentLogos } from '../helpers/logos';

export default defineComponent({
	name: 'FAQ',
	components: {
		TransitionExpand,
		HokImg
	},
	data() {
		return {
			activeItem: -1,
			paymentLogosPricing: getPaymentLogos('pricing'),
			piniaAvailable
		};
	},
	computed: {
		topLevelDomain(): string {
			return piniaAvailable(this.$nuxt, '$userRootStore')
				? this.$nuxt.context.$userRootStore?.topLevelDomain
				: this.$store.state.topLevelDomain || 'at';
		},
		titleClass() {
			let titleClasses: string[];
			switch (this.styling) {
				case 'small':
					titleClasses = ['mb-2'];
					break;
				default:
					titleClasses = ['text-2xl', 'mb-4'];
					break;
			}
			return titleClasses;
		},
		descriptionClass() {
			let descriptionClasses: string[];
			switch (this.styling) {
				case 'small':
					descriptionClasses = ['text-base', 'py-3'];
					break;
				default:
					descriptionClasses = ['pr-2', 'py-6'];
					break;
			}
			return descriptionClasses;
		},
		buttonSize() {
			let buttonSize: number;
			switch (this.styling) {
				case 'small':
					buttonSize = 4;
					break;
				default:
					buttonSize = 6;
					break;
			}
			return buttonSize;
		}
	},
	methods: {
		toggleItem(index: number) {
			if (this.activeItem === index) {
				this.activeItem = -1;
			} else {
				this.$emit('view-answer', index);
				this.activeItem = index;
			}
		}
	},
	props: {
		items: {
			type: Array as PropType<{ title: string; description: string; paymentLogos: any }[]>,
			required: false
		},
		title: { type: String, required: false },
		styling: {
			type: String,
			default: 'default',
			validator: (value: string) => ['default', 'small'].includes(value)
		}
	}
});
